import {Reducer} from "redux";
import { all, fork, takeEvery, put } from "redux-saga/effects";
import {push} from "connected-react-router";

export interface IState {
    dummy: number
} 

export const InitialState: IState = {
    dummy: 0
}

enum ActionTypes {
    ToOutreach = "Navigate.ToOutreach",
    ToOutreachNew = "Navigate.ToOutreachNew",
    ToOutreachDetail = "Navigate.ToOutreachDetail",
    ToOutreachEdit = "Navigate.ToOutreachEdit",
    ToOutreachList = "Navigate.ToOutreachList",
    ToContactpointList = "Navigate.ToContactpointList",
    ToContactpointDetail = "Navigate.ToContactpointDetail",
    ToContactpointEdit = "Navigate.ToContactpointEdit",
    ToContactpointNew = "Navigate.ToContactpointNew",
    ToAutomaticTaskList = "Navigate.ToAutomaticTaskList",
    ToAutomaticTaskDetail = "Navigate.ToAutomaticTaskDetail",
    ToAutomaticTaskEdit = "Navigate.ToAutomaticTaskEdit",
    ToAutomaticTaskNew = "Navigate.ToAutomaticTaskNew",
    ToClientList = "Navigate.ToClientList",
    ToClientDetail = "Navigate.ToClientDetail",
    ToClientEdit = "Navigate.ToClientEdit",
    ToClientNew = "Navigate.ToClientNew",
    ToFileList = "Navigate.ToFileList",
    ToFileDetail = "Navigate.ToFileDetail",
    ToFileEdit = "Navigate.ToFileEdit",
    ToFileNew = "Navigate.ToFileNew",
    ToUrl = "Navigate.ToUrl", // Add a new action type for generic URL navigation
}

interface IOutreach {
    type: ActionTypes.ToOutreach;
}
interface IOutreachNew {
    type: ActionTypes.ToOutreachNew;
}
interface IOutreachDetail {
    type: ActionTypes.ToOutreachDetail;
    id: string;
}
interface IOutreachEdit {
    type: ActionTypes.ToOutreachEdit;
    id: string;
}
interface IOutreachList {
    type: ActionTypes.ToOutreachList;
}
interface IToUrl {
    type: ActionTypes.ToUrl;
    url: string; // Add a URL property
}
interface IContactpointList {
    type: ActionTypes.ToContactpointList;
}
interface IContactpointDetail {
    type: ActionTypes.ToContactpointDetail;
    id: string;
}
interface IContactpointEdit {
    type: ActionTypes.ToContactpointEdit;
    id: string;
}
interface IContactpointNew {
    type: ActionTypes.ToContactpointNew;
}
interface IAutomaticTaskList {
    type: ActionTypes.ToAutomaticTaskList;
}
interface IAutomaticTaskDetail {
    type: ActionTypes.ToAutomaticTaskDetail;
    id: string;
}
interface IAutomaticTaskEdit {
    type: ActionTypes.ToAutomaticTaskEdit;
    id: string;
}
interface IAutomaticTaskNew {
    type: ActionTypes.ToAutomaticTaskNew;
}
interface IClientList {
    type: ActionTypes.ToClientList;
}
interface IClientDetail {
    type: ActionTypes.ToClientDetail;
    id: string;
}
interface IClientEdit {
    type: ActionTypes.ToClientEdit;
    id: string;
}
interface IClientNew {
    type: ActionTypes.ToClientNew;
}
interface IFileList {
    type: ActionTypes.ToFileList;
}
interface IFileDetail {
    type: ActionTypes.ToFileDetail;
    id: string;
}
interface IFileEdit {
    type: ActionTypes.ToFileEdit;
    id: string;
}
interface IFileNew {
    type: ActionTypes.ToFileNew;
    clientStreamId: string;
    clientUuid: string;
}

type Actions = IOutreach | IOutreachNew | IOutreachDetail | IOutreachEdit | IToUrl | IOutreachList | IContactpointList | IContactpointDetail | IContactpointEdit | IContactpointNew | IAutomaticTaskList | IAutomaticTaskDetail | IAutomaticTaskEdit | IAutomaticTaskNew | IClientList | IClientDetail | IClientEdit | IClientNew | IFileList | IFileDetail | IFileEdit | IFileNew;

export const ActionCreators = {
    ToOutreach(): IOutreach {
        return {
            type: ActionTypes.ToOutreach,
        };
    },
    ToOutreachNew(): IOutreachNew {
        return {
            type: ActionTypes.ToOutreachNew,
        };
    },
    ToOutreachDetail(id: string): IOutreachDetail {
        return {
            type: ActionTypes.ToOutreachDetail,
            id,
        };
    },
    ToOutreachEdit(id: string): IOutreachEdit {
        return {
            type: ActionTypes.ToOutreachEdit,
            id,
        };
    },
    ToOutreachList(): IOutreachList {
        return {
            type: ActionTypes.ToOutreachList,
        };
    },
    ToUrl(url: string): IToUrl {
        return {
            type: ActionTypes.ToUrl,
            url, // Pass the URL dynamically
        };
    },
    ToContactpointList(): IContactpointList {
        return {
            type: ActionTypes.ToContactpointList,
        };
    },
    ToContactpointDetail(id: string): IContactpointDetail {
        return {
            type: ActionTypes.ToContactpointDetail,
            id,
        };
    },
    ToContactpointEdit(id: string): IContactpointEdit {
        return {
            type: ActionTypes.ToContactpointEdit,
            id,
        };
    },
    ToContactpointNew(): IContactpointNew {
        return {
            type: ActionTypes.ToContactpointNew,
        };
    },
    ToAutomaticTaskList(): IAutomaticTaskList {
        return {
            type: ActionTypes.ToAutomaticTaskList,
        };
    },
    ToAutomaticTaskDetail(id: string): IAutomaticTaskDetail {
        return {
            type: ActionTypes.ToAutomaticTaskDetail,
            id,
        };
    },
    ToAutomaticTaskEdit(id: string): IAutomaticTaskEdit {
        return {
            type: ActionTypes.ToAutomaticTaskEdit,
            id,
        };
    },
    ToAutomaticTaskNew(): IAutomaticTaskNew {
        return {
            type: ActionTypes.ToAutomaticTaskNew,
        };
    },
    ToClientList(): IClientList {
        return {
            type: ActionTypes.ToClientList,
        };
    },
    ToClientDetail(id: string): IClientDetail {
        return {
            type: ActionTypes.ToClientDetail,
            id,
        };
    },
    ToClientEdit(id: string): IClientEdit {
        return {
            type: ActionTypes.ToClientEdit,
            id,
        };
    },
    ToClientNew(): IClientNew {
        return {
            type: ActionTypes.ToClientNew,
        };
    },
    ToFileList(): IFileList {
        return {
            type: ActionTypes.ToFileList,
        };
    },
    ToFileDetail(id: string): IFileDetail {
        return {
            type: ActionTypes.ToFileDetail,
            id,
        };
    },
    ToFileEdit(id: string): IFileEdit {
        return {
            type: ActionTypes.ToFileEdit,
            id,
        };
    },
    ToFileNew(clientStreamId: string, clientUuid: string): IFileNew {
        return {
            type: ActionTypes.ToFileNew,
            clientStreamId,
            clientUuid,
        };
    },
};

export const Reducers: Reducer<IState, Actions> = (state = InitialState, action) => state;

/*********************************************************************************************
 * Saga's
 */

function* handleToOutreach(action: IOutreach) {
    yield put(push(`/database/outreach/`));
}

function* handleToNewOutreach(action: IOutreachNew) {
    yield put(push('/database/outreach/new'));
}

function* handleToOutreachDetail(action: IOutreachDetail) {
    yield put(push(`/database/outreach/details/${action.id}`));
}

function* handleToOutreachEdit(action: IOutreachEdit) {
    yield put(push(`/database/outreach/edit/${action.id}`));
}

function* handleToOutreachList(action: IOutreachList) {
    yield put(push('/database/outreach/list'));
}

function* handleToUrl(action: IToUrl) {
    yield put(push(action.url)); // Navigate to the specified URL
}

function* handleToContactpointList(action: IContactpointList) {
    yield put(push('/database/contactpoint/'));
}

function* handleToContactpointDetail(action: IContactpointDetail) {
    yield put(push(`/database/contactpoint/details/${action.id}`));
}

function* handleToContactpointEdit(action: IContactpointEdit) {
    yield put(push(`/database/contactpoint/edit/${action.id}`));
}

function* handleToNewContactpoint(action: IContactpointNew) {
    yield put(push('/database/contactpoint/new'));
}

function* handleToAutomaticTaskList(action: IAutomaticTaskList) {
    yield put(push('/database/automatictask/'));
}

function* handleToAutomaticTaskDetail(action: IAutomaticTaskDetail) {
    yield put(push(`/database/automatictask/details/${action.id}`));
}

function* handleToAutomaticTaskEdit(action: IAutomaticTaskEdit) {
    yield put(push(`/database/automatictask/edit/${action.id}`));
}

function* handleToNewAutomaticTask(action: IAutomaticTaskNew) {
    yield put(push('/database/automatictask/new'));
}

function* handleToClientList(action: IClientList) {
    yield put(push('/database/client/'));
}

function* handleToClientDetail(action: IClientDetail) {
    yield put(push(`/database/client/details/${action.id}`));
}

function* handleToClientEdit(action: IClientEdit) {
    yield put(push(`/database/client/edit/${action.id}`));
}

function* handleToNewClient(action: IClientNew) {
    yield put(push('/database/client/new'));
}

function* handleToFileList(action: IFileList) {
    yield put(push('/database/file/'));
}

function* handleToFileDetail(action: IFileDetail) {
    // Redirect to the API endpoint which will forward to the old database
    window.location.href = `/api/redirect/oldFile/${action.id}`;
}

function* handleToFileEdit(action: IFileEdit) {
    yield put(push(`/database/file/edit/${action.id}`));
}

function* handleToNewFile(action: IFileNew) {
    // Redirect to the API endpoint which will forward to the old database
    window.location.href = `/api/redirect/createFile/${action.clientUuid}`;
}

function* watchAll() {
    yield takeEvery(ActionTypes.ToOutreach, handleToOutreach);
    yield takeEvery(ActionTypes.ToOutreachNew, handleToNewOutreach);
    yield takeEvery(ActionTypes.ToOutreachDetail, handleToOutreachDetail);
    yield takeEvery(ActionTypes.ToOutreachEdit, handleToOutreachEdit);
    yield takeEvery(ActionTypes.ToOutreachList, handleToOutreachList);
    yield takeEvery(ActionTypes.ToUrl, handleToUrl); // Watch for the ToUrl action
    yield takeEvery(ActionTypes.ToContactpointList, handleToContactpointList);
    yield takeEvery(ActionTypes.ToContactpointDetail, handleToContactpointDetail);
    yield takeEvery(ActionTypes.ToContactpointEdit, handleToContactpointEdit);
    yield takeEvery(ActionTypes.ToContactpointNew, handleToNewContactpoint);
    yield takeEvery(ActionTypes.ToAutomaticTaskList, handleToAutomaticTaskList);
    yield takeEvery(ActionTypes.ToAutomaticTaskDetail, handleToAutomaticTaskDetail);
    yield takeEvery(ActionTypes.ToAutomaticTaskEdit, handleToAutomaticTaskEdit);
    yield takeEvery(ActionTypes.ToAutomaticTaskNew, handleToNewAutomaticTask);
    yield takeEvery(ActionTypes.ToClientList, handleToClientList);
    yield takeEvery(ActionTypes.ToClientDetail, handleToClientDetail);
    yield takeEvery(ActionTypes.ToClientEdit, handleToClientEdit);
    yield takeEvery(ActionTypes.ToClientNew, handleToNewClient);
    yield takeEvery(ActionTypes.ToFileList, handleToFileList);
    yield takeEvery(ActionTypes.ToFileDetail, handleToFileDetail);
    yield takeEvery(ActionTypes.ToFileEdit, handleToFileEdit);
    yield takeEvery(ActionTypes.ToFileNew, handleToNewFile);
}

export function* Sagas() {
    yield all([fork(watchAll)]);
}